import { ref, readonly } from 'vue';

const state = ref({
    payment: null,
    prices: [],
    promise: null,
    paymentPromise: null,
    upgradeUrl: null,
    upgradeUrlPromise: null
});

const setPayment = (payment) => {
    state.value.payment = payment;
};

const getPayment = (http, refresh = false) => {
    if (state.value.payment && !refresh) return Promise.resolve(state.value.payment);
    if (state.value.paymentPromise) return state.value.paymentPromise;
    state.value.paymentPromise = http.get('/payment').then(({ data }) => {
        state.value.paymentPromise = null;
        setPayment(data);
        return data;
    });
    return state.value.paymentPromise;
};

const getUpgradeUrl = (http) => {
    if (state.value.upgradeUrl) return Promise.resolve(state.value.upgradeUrl);
    if (state.value.upgradeUrlPromise) return state.value.upgradeUrlPromise;
    state.value.upgradeUrlPromise = http.get('/payment/upgrade').then(({ data }) => {
        state.value.upgradeUrlPromise = null;
        state.value.upgradeUrl = data.url;
        return data.url;
    });
    return state.value.upgradeUrlPromise;
};

const set = (prices) => {
    state.value.prices = prices;
};
const get = (http, refresh = false) => {
    if (state.value.prices && state.value.prices.length && !refresh) return Promise.resolve(state.value.prices);
    if (state.value.promise) return state.value.promise;
    state.value.promise = http.get('/payment/prices').then(({ data }) => {
        state.value.promise = null;
        set(data);
        return data;
    });
    return state.value.promise;
};

export default readonly({
    setPayment,
    getPayment,
    getUpgradeUrl,
    set,
    get,
    state
});
